import {
  SEARCH_PROMOTIONS_REQUEST,
  SEARCH_PROMOTIONS_SUCCESS,
  SEARCH_PROMOTIONS_FAILURE,
  GET_PROMOTIONS_REQUEST,
  GET_PROMOTIONS_SUCCESS,
  GET_PROMOTIONS_FAILURE,
  GET_PROMOTION_REQUEST,
  GET_PROMOTION_SUCCESS,
  GET_PROMOTION_FAILURE,
  // ADD_PROMOTION_REQUEST,
  // ADD_PROMOTION_SUCCESS,
  // ADD_PROMOTION_FAILURE,
  UPDATE_PROMOTION_REQUEST,
  UPDATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION_FAILURE,
  DELETE_PROMOTION_REQUEST,
  DELETE_PROMOTION_SUCCESS,
  DELETE_PROMOTION_FAILURE,
  GET_LIST_COUPON_BUDGET_REQUEST,
  GET_LIST_COUPON_BUDGET_SUCCESS,
  GET_LIST_COUPON_BUDGET_FAILURE
} from "src/actions/promotionActions";
import _ from "lodash";
import produce from "immer";

const initialState = {
  promotions: [],
  promotion: {},
  total: 0,
  loadingGets: false,
  loadingGetOne: false,
  loadingUpdate: false,
  loadingUpdatePermission: false,
  loadingUpdateActive: false,
  loadingDelete: false,
  loadingCreatePromotion: false,
  // coupon
  couponBudget: []
};

const promotionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_PROMOTIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.promotions = [];
        draft.loadingGets = true;
      });
    }

    case SEARCH_PROMOTIONS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.promotions = response;
        draft.loadingGets = false;
        draft.total = total;
      });
    }

    case SEARCH_PROMOTIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGets = false;
      });
    }

    // Case Get promotions
    case GET_PROMOTIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.promotions = [];
        draft.loadingGets = true;
      });
    }

    case GET_PROMOTIONS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.promotions = response;
        draft.loadingGets = false;
      });
    }

    case GET_PROMOTIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGets = false;
      });
    }

    // Case Get One
    case GET_PROMOTION_REQUEST: {
      return produce(state, (draft) => {
        draft.promotion = {};
        draft.loadingGetOne = true;
      });
    }

    case GET_PROMOTION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.promotion = response;
        draft.loadingGetOne = false;
      });
    }

    case GET_PROMOTION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOne = false;
      });
    }

    // Case Update promotion
    case UPDATE_PROMOTION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdate = true;
      });
    }

    case UPDATE_PROMOTION_SUCCESS: {
      const {response} = action.payload;
      const updateObj = state.promotions.map((i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateObj !== undefined && updateObj.length > 0) {
        return produce(state, (draft) => {
          draft.promotions = updateObj;
          draft.loadingUpdate = false;
        });
      }
      return produce(state, (draft) => {
        draft.promotions = [response];
        draft.loadingUpdate = false;
      });
    }

    case UPDATE_PROMOTION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdate = false;
      });
    }

    // // Case Update Active promotion
    // case UPDATE_ACTIVE_REQUEST: {
    //   return produce(state, draft => {
    //     draft.loadingUpdateActive = true;
    //   });
    // }
    //
    // case UPDATE_ACTIVE_SUCCESS: {
    //   console.log('UPDATE_ACTIVE_SUCCESS')
    //   const { response } = action.payload;
    //   const updateObj = _.map(state.medias, i => {
    //     if (i.id === response.id) return response;
    //     return i;
    //   })
    //   if (updateObj !== undefined && updateObj.length > 0) {
    //     return produce(state, draft => {
    //       draft.medias = updateObj;
    //       draft.loadingUpdateActive = false;
    //     });
    //   } else return produce(state, draft => {
    //     draft.medias = [response];
    //     draft.loadingUpdateActive = false;
    //   });
    // }
    //
    // case UPDATE_ACTIVE_FAILURE: {
    //   return produce(state, draft => {
    //     draft.loadingUpdateActive = false;
    //   });
    // }

    // Case Delete promotion
    case DELETE_PROMOTION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingDelete = true;
      });
    }

    case DELETE_PROMOTION_SUCCESS: {
      const {promotion} = action.payload;

      const deletePromotion = _.filter(state.promotions, (i) => i.id !== promotion);
      if (deletePromotion !== undefined && deletePromotion.length > 0) {
        return produce(state, (draft) => {
          draft.promotions = deletePromotion;
          draft.loadingDelete = false;
        });
      }
      return produce(state, (draft) => {
        draft.promotions = [];
        draft.loadingDelete = false;
      });
    }

    case DELETE_PROMOTION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingDelete = false;
      });
    }

    // coupon
    case GET_LIST_COUPON_BUDGET_REQUEST: {
      return produce(state, (draft) => {
        draft.couponBudget = [];
        draft.loadingGets = true;
      });
    }

    case GET_LIST_COUPON_BUDGET_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.couponBudget = response;
        draft.loadingGets = false;
      });
    }

    case GET_LIST_COUPON_BUDGET_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGets = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default promotionReducer;
